import { DatePipe } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormControl } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { forkJoin } from "rxjs";
import { ViewChildren, QueryList, ElementRef, ViewChild, TemplateRef } from "@angular/core";
import { MatExpansionPanel } from "@angular/material/expansion";
import { ToastrService } from "ngx-toastr";
import { ActionTrackerService } from "../../../../shared/services/action-tracker.service";
import { ProjectService } from "../../../../shared/services/project.service";
import { IncidentTrackerService } from "../../../../shared/services/incident-tracker.service";
import textConfiguration from "../../../../../assets/static-text-configuration.json";
import { DeletePopupComponent } from "../../delete-popup/delete-popup.component";
import { RiskConvergenceService } from "../../../../shared/services/risk-convergence.service";
import { CommonService } from "../../../../shared/services/common.service";
import { WorkForceService } from "../../../../shared/services/work-force.service";
import { PrismService } from "../../../../shared/services/prism.service";
@Component({
  selector: "app-risklog-dialog",
  templateUrl: "./risklog-dialog.component.html",
  styleUrls: ["./risklog-dialog.component.scss"],
  providers: [DatePipe],
})
export class RisklogDialogComponent implements OnInit {
  @ViewChildren(MatExpansionPanel) panels!: QueryList<MatExpansionPanel>;
  @ViewChildren("panelElement", { read: ElementRef })
  panelElements!: QueryList<ElementRef>;
  commonText: any = (textConfiguration as any).common;
  riskMetric: any;
  res: any;
  riskMetricCreateForm: any;
  riskMetricAcceptCreateForm: any;
  riskMetricTranferCreateForm: any;
  projectId: any;
  riskOwners: any;
  breadCrumbData: any = [];
  riskStatus: any = [];
  deletedMitigationIds: number[] = [];
  mitigationFunctions: any = [];
  actionFileList: { [key: number]: any[] } = {};
  projectDetails: any;
  uploadFiles: Array<any> = [];
  uploadedFiles: Array<any> = [];
  functionOwners: (string | null)[] = [];
  delegatedUsersList: any[] = [];
  delegatedUserNameMap: { [email: string]: string } = {};
  userDetails: any;
  projectOwner: boolean = false;
  acceptCheckboxChecked: boolean = false;
  showCheckboxError: boolean = false;
  mitigateCheckboxChecked: boolean = false;
  showMitigateCheckboxError: boolean = false;
  mitigateStatusId: any = null;
  approvalComments: string = '';
  isLoaded = false;
  preventiveControls: any;
  detectiveControls: any;
  deletedControlIds: number[] = [];
  riskImpactList: any[] = [];
  riskLikelihoodList: any[] = [];
  selectedRiskImpact: any = null;
  selectedRiskLikelihood: any = null;
  initialResidualImpactId: number | null = null;
  initialResidualLikelihoodId: number | null = null;
  inherentRiskScore: number | null = null;
  selectedResidualImpact: any = null;
  selectedResidualLikelihood: any = null;
  residualRiskScore: number | null = null;
  riskMatrixConfig: any[] = [];
  showResidualSection: boolean = false;
  activeTabIndex: number = 0;
  selectedMainTabIndex: number = 0;
  riskControlOptions: any[] = [];
  riskControlTypes: any[] = [];
  actionCommentsMap: { [key: number]: string } = {};
  actionIdMap: { [key: number]: number } = {};

  projectApplications: any[] = [];
  infrastructureList: any[] = [];
  serviceList: any[] = [];
  applicationControl = new FormControl(null);
  selectedInfrastructureIds: any[] = [];
  selectedServiceIds: any[] = [];

  infraSearchText: string = '';
  serviceSearchText: string = '';

  assetImpactList: any[] = [];
  selectedAssetImpact: any = null;

  get selectedApplicationId(): any {
    return this.applicationControl.value;
  }

  displayDelegatedUser = (user: any): string =>
    user ? `${user.first_name ?? ""} ${user.last_name ?? ""}`.trim() : "";

  moduleName: string = (textConfiguration as any)?.modules?.risknet


  @ViewChild('historyDialogTemplate') historyDialogTemplate!: TemplateRef<any>;
  @ViewChild('actionHistoryDialogTemplate') actionHistoryDialogTemplate!: TemplateRef<any>;

  constructor(
    public dialogRef: MatDialogRef<RisklogDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public fb: FormBuilder,
    public datepipe: DatePipe,
    private readonly projectService: ProjectService,
    private readonly toastrService: ToastrService,
    private readonly actionTrackerService: ActionTrackerService,
    private readonly incidentTrackerService: IncidentTrackerService,
    private readonly dialog: MatDialog,
    private readonly riskService: RiskConvergenceService,
    private readonly commonService: CommonService,
    private readonly workForceService: WorkForceService,
    private readonly prismService: PrismService
  ) { }

  ngOnInit(): void {
    this.riskMetric = this.data.riskMetric || {};
    this.res = this.data.res;
    if (!this.riskMetric.id && this.res?.id) {
      this.riskMetric.id = this.res.id;
    }
    const dbResponse = this.res?.risk_response || this.riskMetric?.risk_response;
    this.riskMetric.risk_response = (dbResponse && dbResponse !== '') ? dbResponse : "Mitigate";
    this.breadCrumbData = this.data.breadCrumbData || [];
    this.projectId = this.data.projectId;
    if (this.data?.selectedMainTabIndex !== undefined && this.data?.selectedMainTabIndex !== null) {
      this.selectedMainTabIndex = this.data.selectedMainTabIndex;
    }
    this.riskMetricCreateForm = this.fb.array([]);
    this.preventiveControls = this.fb.array([]);
    this.detectiveControls = this.fb.array([]);
    this.riskMetricCreateForm.clear();
    this.riskService.getRiskMatrixConfig().subscribe((config: any) => {
      if (Array.isArray(config) && config.length) {
        this.riskMatrixConfig = config;
      }
    });
    this.getRiskOwners();
    this.initialiseForm();
    forkJoin({
      impact: this.riskService.getRiskImpactList(),
      likelihood: this.riskService.getRiskLikelihoodList(),
    }).subscribe((res: any) => {
      this.riskImpactList = res.impact || [];
      this.riskLikelihoodList = res.likelihood || [];

      this.setRiskScoreFromRes();
      this.handleRes();
    });
    this.getProjectRiskStatus();
    this.getMitigationFunctions();
    this.getRiskControls();
    this.getRiskControlTypes();
    this.getProjectApplications();
    this.getAssetImpactList();
    this.userDetails = JSON.parse(localStorage.getItem("permission") ?? "{}");
    const isModuleOwner = this.userDetails.is_module_owner;
    const moduleOwner = this.userDetails.owned_modules.includes(this.moduleName);
    this.projectOwner = (isModuleOwner && moduleOwner) || (this.userDetails.accessible_modules || []).includes(this.moduleName) || this.userDetails.is_superuser;

  }

  getRiskControls() {
    const riskId = this.riskMetric?.id || this.res?.id;
    if (!riskId) return;
    this.riskService
      .getRiskControls(riskId)
      .subscribe((res: any) => {
        this.riskControlOptions = res;
      });
  }

  getRiskControlTypes() {
    this.riskService.getRiskControlTypes().subscribe((res: any) => {
      this.riskControlTypes = res;
    });
  }

  getProjectApplications() {
    if (!this.projectId) return;
    this.workForceService.getMappedApplications(this.projectId).subscribe((res: any) => {
      this.projectApplications = res?.data || [];
    });
  }

  get filteredInfrastructures(): any[] {
    if (!this.infraSearchText) return this.infrastructureList;
    const term = this.infraSearchText.toLowerCase();
    return this.infrastructureList.filter((i: any) => (i.infrastructure_name || i.name || '').toLowerCase().includes(term));
  }

  get filteredServices(): any[] {
    if (!this.serviceSearchText) return this.serviceList;
    const term = this.serviceSearchText.toLowerCase();
    return this.serviceList.filter((s: any) => (s.service_name || s.name || '').toLowerCase().includes(term));
  }

  onApplicationChange(applicationId: any, isInitialLoad: boolean = false) {
    if (!isInitialLoad) {
      this.selectedInfrastructureIds = [];
      this.selectedServiceIds = [];
      this.infraSearchText = '';
      this.serviceSearchText = '';
    }
    this.applicationControl.setValue(applicationId, { emitEvent: false });
    this.infrastructureList = [];
    this.serviceList = [];

    if (!applicationId) {
      this.selectedAssetImpact = null;
      this.calculateRiskScore();
      this.calculateResidualRiskScore();
      return;
    }

    this.prismService.getApplicationById(applicationId).subscribe((res: any) => {
      const rawInfra = res?.infrastructure_usages || res?.infrastructure_usage || [];
      this.infrastructureList = rawInfra.map((item: any) => item.infrastructure || item);
      this.serviceList = res?.mapped_services || [];
    });
  }

  getMitigationFunctions() {
    this.projectService.getMitigationFunctions().subscribe((res: any) => {
      this.mitigationFunctions = res;
    });
  }

  historyDialogRef!: MatDialogRef<any>;
  actionHistoryDialogRef!: MatDialogRef<any>;

  openHistory() {
    this.historyDialogRef = this.dialog.open(this.historyDialogTemplate, {
      width: '600px',
      maxHeight: '80vh',
      panelClass: 'history-dialog-panel'
    });
  }

  openActionHistoryDialog(actionId: number) {
    this.actionHistoryDialogRef = this.dialog.open(this.actionHistoryDialogTemplate, {
      width: '600px',
      maxHeight: '90vh',
      data: actionId
    });
  }

  getProjectRiskStatus() {
    this.projectService.getProjectRiskStatus().subscribe((res: any) => {
      this.riskStatus = res;
    });
  }
  getRiskOwners() {
    this.projectService.getRiskOwners().subscribe((getRiskOwner: any) => {
      this.riskOwners = getRiskOwner.users;
    });
  }

  setRiskResponse(response: 'Accept' | 'Mitigate') {
    if (this.isReadOnlyStatus()) return;
    this.riskMetric.risk_response = response;
    this.handleRes();
  }

  handleRes() {
    this.riskMetricCreateForm.clear();
    this.actionFileList = {};
    this.functionOwners = [];
    this.delegatedUsersList = [];
    this.delegatedUserNameMap = {};
    this.mitigateCheckboxChecked = false;
    this.showMitigateCheckboxError = false;
    this.mitigateStatusId = null;
    this.approvalComments = '';

    this.applicationControl.setValue(this.res?.application?.id || this.res?.application || null, { emitEvent: false });

    this.selectedInfrastructureIds = (this.res?.infrastructures || []).map((i: any) => i.id || i);
    if (this.selectedInfrastructureIds.length === 0 && (this.res?.infrastructure?.id || this.res?.infrastructure)) {
      this.selectedInfrastructureIds = [this.res?.infrastructure?.id || this.res?.infrastructure];
    }

    this.selectedServiceIds = (this.res?.services || []).map((s: any) => s.id || s);
    if (this.selectedServiceIds.length === 0 && (this.res?.service?.id || this.res?.service)) {
      this.selectedServiceIds = [this.res?.service?.id || this.res?.service];
    }

    this.setAssetImpactFromRes();

    if (this.selectedApplicationId) {
      this.onApplicationChange(this.selectedApplicationId, true);
    }

    if (this.riskMetric.risk_response === "Mitigate") {
      this.preventiveControls.clear();
      this.detectiveControls.clear();

      const preventive = this.res?.preventive_controls || [];
      const detective = this.res?.detective_controls || [];

      if (preventive.length) {
        preventive.forEach((c: any) => {
          this.preventiveControls.push(this.createControlRow(c));
        });
      } else {
        this.preventiveControls.push(this.createControlRow());
      }

      if (detective.length) {
        detective.forEach((c: any) => {
          this.detectiveControls.push(this.createControlRow(c));
        });
      } else {
        this.detectiveControls.push(this.createControlRow());
      }
      this.res.risk_mitigation.forEach((element: any, index: number) => {
        let ownerVal: any = element.owner?.email || null;

        this.actionFileList[index] =
          element?.risk_mitigation?.action?.files || [];
        this.actionCommentsMap[index] =
          element?.risk_mitigation?.action?.comments || "";
        this.actionIdMap[index] =
          element?.risk_mitigation?.action?.id || null;
        const masterMitId = element.risk_mitigation?.master_mitigation?.id ||
          element.risk_mitigation?.master_mitigation ||
          element.master_mitigation?.id ||
          element.master_mitigation || null;
        const isIgnoredVal = element.risk_mitigation?.is_ignored ?? element.is_ignored ?? false;

        const hasAction = !!(element.has_action || element?.risk_mitigation?.action?.id || element?.risk_mitigation?.action);
        const actionStatus = element?.risk_mitigation?.action?.status;
        const effectiveStatus = (hasAction && actionStatus) ? actionStatus : (element.status || 'Open');

        this.riskMetricCreateForm.push(
          this.fb.group({
            id: [element.id],
            mitigation_task: [element.risk_mitigation?.action_tasks],
            due_date: [element.planned_end_date],
            status: [effectiveStatus],
            comments: [element.remarks],
            action_comments: [element?.risk_mitigation?.action?.comments || ""],
            owner: ownerVal,
            function: [element.function?.id || null],
            delegated_to: [element.delegated_to?.email || null],
            type: [element.type?.id || element.type || null],
            has_action: [hasAction],
            review_decision: [null],
            master_mitigation: [masterMitId],
            is_ignored: [isIgnoredVal],
            add_to_master: [false],
          })
        );
        if (element.function?.id) {
          this.onFunctionChange(element.function.id, index, false);
        }
      });

      // Track existing master mitigation IDs linked to this project risk
      const existingMasterIds = new Set<number>();
      (this.res?.risk_mitigation || []).forEach((m: any) => {
        const masterId = m.risk_mitigation?.master_mitigation?.id ||
          m.risk_mitigation?.master_mitigation ||
          m.master_mitigation?.id ||
          m.master_mitigation;
        if (masterId) {
          existingMasterIds.add(Number(masterId));
        }
      });

      // Auto-populate any new master risk mitigations not yet present (active cycle only)
      if (!this.data.isReadOnly) {
        const masterMitigations = this.res?.risk_master_mitigations || [];
        masterMitigations.forEach((masterItem: any) => {
          if (masterItem.id && !existingMasterIds.has(Number(masterItem.id))) {
            const newIdx = this.riskMetricCreateForm.length;
            this.functionOwners[newIdx] = "";
            this.delegatedUsersList[newIdx] = [];
            this.riskMetricCreateForm.push(
              this.fb.group({
                id: [null],
                mitigation_task: [masterItem.task || ""],
                due_date: [""],
                status: ["Open"],
                comments: [""],
                action_comments: [""],
                owner: [""],
                function: [""],
                delegated_to: [""],
                type: [null],
                has_action: [false],
                review_decision: [null],
                master_mitigation: [masterItem.id],
                is_ignored: [false],
                add_to_master: [false],
              })
            );
          }
        });
      }

      const alreadyClosed = this.isClosedByCro();
      this.mitigateCheckboxChecked = alreadyClosed;
      if (alreadyClosed) {
        this.mitigateStatusId = this.res?.status?.id ?? null;
      }

      if (alreadyClosed || this.allMitigationTasksClosed || this.res?.status?.name === 'Closed' || this.data.mitigationTab === 'completed') {
        this.activeTabIndex = 2; // Default to Completed Tasks tab when Closed/Completed or requested by notification
      } else {
        this.activeTabIndex = 0; // Default back to For Review tab otherwise
      }
      this.approvalComments = this.res?.approval_comments || '';
    }

    if (this.riskMetric.risk_response === "Accept") {
      this.riskMetricAcceptCreateForm.patchValue({
        comments: this.res.comments,
        status: this.res?.status?.id,
        due_date: this.res?.due_date ? new Date(this.res?.due_date) : null,
      });
      this.uploadedFiles = this.res?.files || [];
      const isClosed = this.isClosedByCro();
      this.acceptCheckboxChecked = isClosed;
      this.showResidualSection = isClosed;
      if (isClosed) {
        this.selectedResidualImpact = this.selectedRiskImpact;
        this.selectedResidualLikelihood = this.selectedRiskLikelihood;
        this.residualRiskScore = this.inherentRiskScore;
      }
    }
    setTimeout(() => {
      if (this.isReadOnlyStatus()) {
        this.riskMetricAcceptCreateForm.disable();
        this.preventiveControls.disable();
        this.detectiveControls.disable();
      } else {
        this.riskMetricAcceptCreateForm.enable();
        this.preventiveControls.enable();
        this.detectiveControls.enable();
      }

      if (this.isClosedByCro()) {
        this.riskMetricCreateForm.disable();
      } else {
        this.riskMetricCreateForm.enable();
        this.updateStatusControlsState();
      }
      this.isLoaded = true;
    }, 100);
  }

  initialiseForm() {
    this.riskMetricAcceptCreateForm = this.fb.group({
      comments: [""],
      status: [""],
      due_date: [""],
    });
  }

  addMetricItems() {
    if (this.projectOwner) {
      return;
    }
    const index = this.riskMetricCreateForm.length;

    this.functionOwners[index] = "";
    this.delegatedUsersList[index] = [];
    this.riskMetricCreateForm.push(
      this.fb.group({
        id: [null],
        mitigation_task: [""],
        due_date: [""],
        status: ["Open"],
        comments: [""],
        owner: [""],
        function: [""],
        delegated_to: [""],
        type: [null],
        has_action: [false],
        review_decision: [null],
        add_to_master: [false],
      })
    );
    this.updateStatusControlsState();

    setTimeout(() => {
      const panels = this.panels.toArray();
      const panelEls = this.panelElements.toArray();

      const newPanel = panels[panels.length - 1];
      const newPanelEl = panelEls[panelEls.length - 1];

      if (newPanel && newPanelEl) {
        newPanel.open();

        newPanel.afterExpand.subscribe(() => {
          newPanelEl.nativeElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        });
      }
    });
  }

  removeMetric(index: number) {
    if (this.projectOwner) {
      return;
    }
    const control = this.riskMetricCreateForm.at(index);
    if (!control) return;
    const item = control.value;

    if (item?.master_mitigation) {
      control.patchValue({ is_ignored: !item.is_ignored });
      this.updateStatusControlsState();
      return;
    }

    if (item?.id) {
      this.deletedMitigationIds.push(item.id);
    }
    this.riskMetricCreateForm.removeAt(index);
    this.updateStatusControlsState();
  }

  downloadFile(fileId: number, fileName: string) {
    this.actionTrackerService.downloadActionTrackerFile(fileId).subscribe(
      (res: any) => {
        const downloadLink = document.createElement("a");
        downloadLink.href = window.URL.createObjectURL(res);
        downloadLink.setAttribute("download", fileName);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.toastrService.success("File downloaded successfully");
      },
      () => {
        this.toastrService.error("Unable to download file");
      }
    );
  }

  closeDialog() {
    this.dialogRef.close();
  }

  saveMetric(isAcceptRisk: boolean = false) {
    if (this.riskMetric.risk_response === "Accept") {
      if (!this.projectOwner) {
        return;
      }

      if (!this.acceptCheckboxChecked) {
        this.showCheckboxError = true;
        return;
      }

      this.saveAccept();
      return;
    }

    if (this.riskMetric.risk_response === "Mitigate") {
      if (isAcceptRisk && this.projectOwner && !this.mitigateCheckboxChecked) {
        this.showMitigateCheckboxError = true;
        return;
      }
      this.saveMitigate(isAcceptRisk);
    }
  }

  onFunctionChange(functionId: number, index: number, resetDelegated = true) {
    if (!functionId) return;

    this.riskService.getRiskFunctionOwners(functionId).subscribe((res: any) => {
      const formGroup = this.riskMetricCreateForm.at(index);

      const ownerEmail = res.owner?.email || null;

      const ownerName = res.owner
        ? `${res.owner.first_name} ${res.owner.last_name}`
        : null;

      this.functionOwners[index] = ownerName;
      this.delegatedUsersList[index] = res.delegated_users || [];
      (res.delegated_users || []).forEach((user: any) => {
        this.delegatedUserNameMap[user.email] =
          `${user.first_name} ${user.last_name}`;
      });

      formGroup.patchValue({
        owner: ownerEmail,
        delegated_to: resetDelegated ? null : formGroup.value.delegated_to,
      });
    });
  }

  private validateMitigationTasks(mitigationList: any): boolean {
    if (!mitigationList || mitigationList.length === 0) {
      this.toastrService.error("At least one task is mandatory");
      return false;
    }

    const mandatoryFields: { key: string; label: string }[] = [
      { key: "mitigation_task", label: "Mitigation Task" },
      { key: "function", label: "Function" },
      { key: "delegated_to", label: "Delegated To" },
      { key: "due_date", label: "Due Date" },
      { key: "status", label: "Status" },
    ];

    for (let i = 0; i < mitigationList.length; i++) {
      const element = mitigationList[i];
      if (element.is_ignored) continue;

      const taskLabel = element.mitigation_task?.trim()
        ? `Task ${i + 1} "${element.mitigation_task}"`
        : `Task ${i + 1}`;

      for (const field of mandatoryFields) {
        const value = element[field.key];
        const isEmpty =
          value === null ||
          value === undefined ||
          (typeof value === "string" && value.trim() === "");

        if (isEmpty) {
          this.toastrService.warning(
            `${field.label} is required in ${taskLabel}`
          );
          return false;
        }
      }
    }

    return true;
  }

  saveMitigate(isAcceptRisk: boolean = false) {
    const mitigationList = this.riskMetricCreateForm.getRawValue();
    if (!this.validateMitigationTasks(mitigationList)) return;

    if (this.showApprovalControls() && this.hasSelectedDecision() && !this.approvalComments?.trim()) {
      this.toastrService.warning("Please provide CRO Comments for your decisions.");
      return;
    }

    const created: any[] = [];
    const updated: any[] = [];

    mitigationList.forEach((element: any) => {
      const formattedDate = element.due_date
        ? this.datepipe.transform(element.due_date, "yyyy-MM-dd")
        : null;

      const payload = {
        id: element.id,
        mitigation_task: element.mitigation_task,
        due_date: formattedDate,
        status: element.status,
        comments: element.comments,
        owner: element.owner || null,
        delegated_to: element.delegated_to || null,
        function: element.function || null,
        type: element.type || null,
        review_decision: element.review_decision || null,
        action_comments: element.action_comments || null,
        master_mitigation: element.master_mitigation || null,
        is_ignored: element.is_ignored || false,
        add_to_master: element.add_to_master || false,
      };

      if (element.id) {
        updated.push(payload);
      } else {
        created.push(payload);
      }
    });

    const controlsCreated: any[] = [];
    const controlsUpdated: any[] = [];

    this.preventiveControls.value.forEach((ctrl: any) => {
      if (!ctrl.description) return;

      const payload: any = {
        id: ctrl.id,
        description: ctrl.description.description || ctrl.description,
        control_type: "preventive",
        type: ctrl.type,
      };

      // Cases (1) and (2): user picked from dropdown
      if (ctrl.master_risk_control_id !== null) {
        payload.master_risk_control_id = ctrl.master_risk_control_id;
        payload.modified = ctrl.modified;
      }

      if (ctrl.id) {
        controlsUpdated.push(payload);
      } else {
        controlsCreated.push(payload);
      }
    });

    this.detectiveControls.value.forEach((ctrl: any) => {
      if (!ctrl.description) return;

      const payload: any = {
        id: ctrl.id,
        description: ctrl.description.description || ctrl.description,
        control_type: "detective",
        type: ctrl.type,
      };

      // Cases (1) and (2): user picked from dropdown
      if (ctrl.master_risk_control_id !== null) {
        payload.master_risk_control_id = ctrl.master_risk_control_id;
        payload.modified = ctrl.modified;
      }

      if (ctrl.id) {
        controlsUpdated.push(payload);
      } else {
        controlsCreated.push(payload);
      }
    });

    // Resolve status ID
    let finalStatus: any = null;
    const activeMitigationList = mitigationList.filter((m: any) => !m.is_ignored);
    const approvedCount = activeMitigationList.filter((m: any) => m.review_decision === 'Approve').length;
    const rejectedCount = activeMitigationList.filter((m: any) => m.review_decision === 'Reject').length;
    const forReviewCount = activeMitigationList.filter((m: any) => !m.has_action).length;

    if (this.showApprovalControls() && approvedCount > 0) {
      finalStatus = 'Approved';
    } else if (this.showApprovalControls() && forReviewCount > 0 && rejectedCount === forReviewCount && this.res?.status?.name === 'Under Review') {
      finalStatus = 'Rejected';
    } else if (isAcceptRisk && this.mitigateCheckboxChecked) {
      const closedByCroStatus = this.riskStatus.find(
        (s: any) => s.name === 'Closed by CRO'
      );
      finalStatus = closedByCroStatus?.id ?? 'Closed by CRO';
    } else if (forReviewCount === 0 && created.length === 0) {
      const allClosed = activeMitigationList.length > 0 && activeMitigationList.every((m: any) => m.status === 'Closed');
      if (allClosed) {
        const closedStatus = this.riskStatus.find((s: any) => s.name === 'Closed');
        finalStatus = closedStatus?.id ?? this.res?.status?.id;
      } else {
        const wipStatus = this.riskStatus.find((s: any) => s.name === 'WIP');
        finalStatus = wipStatus?.id ?? this.res?.status?.id;
      }
    } else {
      const underReviewStatus = this.riskStatus.find(
        (s: any) => s.name === 'Under Review'
      );
      finalStatus = underReviewStatus?.id ?? null;
    }

    const postdata = {
      created,
      updated,
      deleted: this.deletedMitigationIds || [],

      controls: {
        created: controlsCreated,
        updated: controlsUpdated,
        deleted: this.deletedControlIds || [],
      },
      risk_impact: this.selectedRiskImpact?.id || null,
      risk_likelihood: this.selectedRiskLikelihood?.id || null,

      residual_risk_impact: this.effectiveResidualImpact?.id || null,
      residual_risk_likelihood: this.effectiveResidualLikelihood?.id || null,
      residual_risk_score: this.effectiveResidualRiskScore || null,

      status: finalStatus,
      approval_comments: this.approvalComments || null,

      application: this.selectedApplicationId || null,
      infrastructures: this.selectedInfrastructureIds || [],
      services: this.selectedServiceIds || [],
      asset_impact: this.selectedAssetImpact?.id || null,

      risk_response: "Mitigate",
    };

    const queryParam = `?risk=${this.riskMetric.risk_id}&project=${this.projectId}`;

    this.projectService
      .setRiskResponse(queryParam, postdata, this.moduleName)
      .subscribe((res: any) => {
        this.deletedMitigationIds = [];

        this.deletedControlIds = [];

        this.dialogRef.close({ riskId: this.riskMetric.risk_id, res });
        this.toastrService.success("Risk updated successfully");
      });
  }

  saveAccept() {
    const formValues = { ...this.riskMetricAcceptCreateForm.value };

    if (formValues.due_date) {
      formValues.due_date = this.datepipe.transform(
        formValues.due_date,
        "yyyy-MM-dd"
      );
    }

    const formData = new FormData();

    Object.keys(formValues).forEach((key) => {
      if (formValues[key] !== null && formValues[key] !== undefined) {
        formData.append(key, formValues[key]);
      }
    });

    // attach uploaded files
    if (this.uploadFiles?.length) {
      this.uploadFiles.forEach((file: File) => {
        formData.append("files", file);
      });
    }

    formData.append("risk_response", "Accept");

    if (this.selectedRiskImpact?.id) {
      formData.append("risk_impact", this.selectedRiskImpact.id);
    }

    if (this.selectedRiskLikelihood?.id) {
      formData.append("risk_likelihood", this.selectedRiskLikelihood.id);
    }

    if (this.selectedApplicationId) {
      formData.append("application", this.selectedApplicationId);
    }
    if (this.selectedInfrastructureIds?.length) {
      this.selectedInfrastructureIds.forEach((id: any) => {
        formData.append("infrastructures", id);
      });
    }
    if (this.selectedServiceIds?.length) {
      this.selectedServiceIds.forEach((id: any) => {
        formData.append("services", id);
      });
    }

    formData.append("asset_impact", this.selectedAssetImpact?.id ? this.selectedAssetImpact.id : "");

    const queryParam = `?risk=${this.riskMetric.risk_id}&project=${this.projectId}`;

    this.projectService
      .setRiskResponse(queryParam, formData, this.moduleName)
      .subscribe((res: any) => {
        this.uploadFiles = [];
        this.dialogRef.close({ riskId: this.riskMetric.risk_id, res });
        this.toastrService.success("Risk updated successfully");
      });
  }

  isClosed(): boolean {
    const closedStatus = this.riskStatus.find(
      (s: any) => s.name === "Closed by CRO"
    );

    return (
      this.riskMetricAcceptCreateForm.get("status")?.value === closedStatus?.id
    );
  }

  isReadOnlyStatus(): boolean {
    const status = (this.res?.status?.name || '').toLowerCase();
    return (
      !!this.data?.isReadOnly ||
      this.res?.cycle?.is_active === false ||
      status === 'closed by cro'
    );
  }

  isClosedByCro(): boolean {
    const status = (this.res?.status?.name || '').toLowerCase();
    return status === 'closed by cro';
  }

  isStatusDisabled(m: any): boolean {
    if (this.isReadOnlyStatus()) return true;
    if (!m) return true;
    const val = m.getRawValue ? m.getRawValue() : m.value;
    if (!val) return true;
    if (this.isClosedByCro() || val.is_ignored) return true;
    return !(this.projectOwner && val.status === 'Closed' && val.has_action);
  }

  updateStatusControlsState() {
    this.riskMetricCreateForm?.controls?.forEach((group: any) => {
      const statusCtrl = group.get('status');
      if (this.isStatusDisabled(group)) {
        statusCtrl?.disable({ emitEvent: false });
      } else {
        statusCtrl?.enable({ emitEvent: false });
      }
    });
  }

  isMitigateCheckboxEnabled(): boolean {
    return this.res?.status?.name === 'Closed' && this.allMitigationTasksClosed;
  }

  showApprovalControls(): boolean {
    if (!this.projectOwner) return false;

    if (this.res?.status?.name === 'Under Review') {
      return true;
    }

    if (this.res?.status?.name === 'WIP') {
      const mitigations = this.riskMetricCreateForm?.value || [];
      return mitigations.some((m: any) => !m.has_action && !m.is_ignored);
    }

    if (this.res?.status?.name === 'Closed') {
      return !this.allMitigationTasksClosed;
    }

    return false;
  }

  hasSelectedDecision(): boolean {
    const mitigations = this.riskMetricCreateForm?.value || [];
    return mitigations.some((m: any) => m.review_decision === 'Approve' || m.review_decision === 'Reject');
  }

  getForReviewIndexes(): number[] {
    const activeIndexes: number[] = [];
    const ignoredIndexes: number[] = [];
    this.riskMetricCreateForm?.controls.forEach((ctrl: any, index: number) => {
      const val = ctrl.getRawValue();
      if (!val.has_action) {
        if (val.is_ignored) {
          ignoredIndexes.push(index);
        } else {
          activeIndexes.push(index);
        }
      }
    });
    return [...activeIndexes, ...ignoredIndexes];
  }

  getForReviewCount(): number {
    let count = 0;
    this.riskMetricCreateForm?.controls.forEach((ctrl: any) => {
      const val = ctrl.getRawValue();
      if (!val.has_action && !val.is_ignored) {
        if (this.projectOwner) {
          if (val.delegated_to && val.due_date) {
            count++;
          }
        } else {
          count++;
        }
      }
    });
    return count;
  }

  getWipIndexes(): number[] {
    const activeIndexes: number[] = [];
    const ignoredIndexes: number[] = [];
    this.riskMetricCreateForm?.controls.forEach((ctrl: any, index: number) => {
      const val = ctrl.getRawValue();
      if (val.has_action && val.status !== 'Closed') {
        if (val.is_ignored) {
          ignoredIndexes.push(index);
        } else {
          activeIndexes.push(index);
        }
      }
    });
    return [...activeIndexes, ...ignoredIndexes];
  }

  getCompletedIndexes(): number[] {
    const activeIndexes: number[] = [];
    const ignoredIndexes: number[] = [];
    this.riskMetricCreateForm?.controls.forEach((ctrl: any, index: number) => {
      const val = ctrl.getRawValue();
      if (val.has_action && val.status === 'Closed') {
        if (val.is_ignored) {
          ignoredIndexes.push(index);
        } else {
          activeIndexes.push(index);
        }
      }
    });
    return [...activeIndexes, ...ignoredIndexes];
  }

  resolveMitigateStatusId(isChecked: boolean) {
    if (isChecked) {
      const closedStatus = this.riskStatus.find(
        (s: any) => s.name === 'Closed by CRO'
      );
      this.mitigateStatusId = closedStatus?.id ?? null;
    } else {
      this.mitigateStatusId = null;
    }
  }

  toggleStatus(isChecked: boolean) {
    this.acceptCheckboxChecked = isChecked;
    this.showCheckboxError = false;

    const closedStatus = this.riskStatus.find(
      (s: any) => s.name === "Closed by CRO"
    );

    const openStatus = this.riskStatus.find(
      (s: any) => s.name === "Submitted"
    );

    const statusId = isChecked ? closedStatus?.id : openStatus?.id;

    this.riskMetricAcceptCreateForm.patchValue({
      status: statusId,
    });

    if (isChecked) {
      this.selectedResidualImpact = this.selectedRiskImpact;
      this.selectedResidualLikelihood = this.selectedRiskLikelihood;
      this.residualRiskScore = this.inherentRiskScore;
    }
  }

  onFileSelected(event: any) {
    const files = event.target.files;
    if (files?.length) {
      for (let file of files) {
        const fileAreadyUploaded = this.uploadedFiles.some(
          (uploadedFile: any) => {
            return uploadedFile.file_name === file.name;
          }
        );
        const fileAlreadyInUplaodNew = this.uploadFiles.some(
          (uplaodFile: any) => {
            return uplaodFile.name === file.name;
          }
        );
        if (fileAlreadyInUplaodNew) {
          this.toastrService.error(
            `File ${file.name} is already added to upload`
          );
          break;
        } else if (fileAreadyUploaded) {
          this.toastrService.error(`File ${file.name} already exists`);
          break;
        } else {
          this.commonService.validateFileSize(file).subscribe((isValid) => {
            if (!isValid) {
              this.toastrService.error("Please upload less than 50MB");
              return;
            }
            this.uploadFiles.push(file);
          });
        }
      }
      event.target.value = "";
    }
  }

  removeFile(fileIndex: number) {
    if (
      fileIndex !== null &&
      fileIndex >= 0 &&
      fileIndex < this.uploadFiles.length
    ) {
      this.uploadFiles.splice(fileIndex, 1);
    }
  }

  removeUploadedFile(fileId: number, fileIndex: number) {
    let dialog = this.dialog.open(DeletePopupComponent, {
      data: this.uploadedFiles[fileIndex].file_name,
    });

    dialog.afterClosed().subscribe((res: any) => {
      if (res) {
        this.riskService.deleteFile(fileId).subscribe(
          (res: any) => {
            this.uploadedFiles.splice(fileIndex, 1);
            this.toastrService.success("File removed");
          },
          (err: any) => {
            this.toastrService.error("Failed to remove file!");
          }
        );
      }
    });
  }

  downloadRiskFile(fileId: number, fileIndex: number) {
    this.riskService.downloadFile(fileId).subscribe(
      (res: any) => {
        const downloadLink = document.createElement("a");
        downloadLink.href = window.URL.createObjectURL(res);
        downloadLink.setAttribute(
          "download",
          this.uploadedFiles[fileIndex].file_name
        );
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.toastrService.success("File downloaded successfully");
      },
      (err: any) => {
        this.toastrService.error("Unable to download file");
      }
    );
  }

  getFunctionName(id: any) {
    return this.mitigationFunctions.find((f: any) => f.id === id)?.display_name;
  }

  createControlRow(data: any = {}) {
    return this.fb.group({
      id: [data.id || null],
      description: [data.description || ""],
      master_risk_control_id: [data.master_risk_control || null],
      type: [data.type?.id || data.type || null],
      modified: [false],
      _originalDescription: [null], // tracks the original selected text
    });
  }

  onControlSelected(option: any, controlGroup: any) {
    controlGroup.patchValue({
      master_risk_control_id: option.id,
      modified: false,
      _originalDescription: option.description,
    });
  }

  onControlInput(controlGroup: any) {
    const original = controlGroup.get("_originalDescription")?.value;
    if (original === null) return; // case (3) — free typed, no selection made

    const current = controlGroup.get("description")?.value;
    controlGroup.patchValue(
      {
        modified: current !== original,
      },
      { emitEvent: false }
    );
  }

  addPreventiveControl() {
    this.preventiveControls.push(this.createControlRow());
  }

  removePreventiveControl(index: number) {
    const item = this.preventiveControls.at(index).value;

    if (item?.id) {
      this.deletedControlIds.push(item.id);
    }

    this.preventiveControls.removeAt(index);

    if (this.preventiveControls.length === 0) {
      this.preventiveControls.push(this.createControlRow());
    }
  }

  addDetectiveControl() {
    this.detectiveControls.push(this.createControlRow());
  }

  removeDetectiveControl(index: number) {
    const item = this.detectiveControls.at(index).value;

    if (item?.id) {
      this.deletedControlIds.push(item.id);
    }

    this.detectiveControls.removeAt(index);

    if (this.detectiveControls.length === 0) {
      this.detectiveControls.push(this.createControlRow());
    }
  }

  getRiskImpactList() {
    this.riskService.getRiskImpactList().subscribe((res: any) => {
      this.riskImpactList = res || [];
    });
  }

  getRiskLikelihoodList() {
    this.riskService.getRiskLikelihoodList().subscribe((res: any) => {
      this.riskLikelihoodList = res || [];
    });
  }

  getAssetImpactList() {
    this.riskService.getAssetImpactList().subscribe((res: any) => {
      this.assetImpactList = res || [];
      this.setAssetImpactFromRes();
    });
  }

  setAssetImpactFromRes() {
    if (!this.res) return;
    const rawAsset = this.res.asset_impact || this.res.risk?.asset_impact;
    const assetId = typeof rawAsset === 'object' ? rawAsset?.id : rawAsset;
    if (assetId && this.assetImpactList.length > 0) {
      this.selectedAssetImpact = this.assetImpactList.find(a => a.id === Number(assetId)) || null;
    } else {
      this.selectedAssetImpact = null;
    }
    this.calculateRiskScore();
    this.calculateResidualRiskScore();
  }

  onAssetImpactChange(assetImpactId: any) {
    if (!assetImpactId) {
      this.selectedAssetImpact = null;
    } else {
      this.selectedAssetImpact = this.assetImpactList.find(a => a.id === Number(assetImpactId)) || null;
    }
    this.calculateRiskScore();
    this.calculateResidualRiskScore();
  }

  calculateRiskScore() {
    if (this.selectedRiskImpact && this.selectedRiskLikelihood) {
      const impactScore = Number(
        this.selectedRiskImpact.name || this.selectedRiskImpact.id
      );
      const likelihoodScore = Number(
        this.selectedRiskLikelihood.name || this.selectedRiskLikelihood.id
      );
      const assetMult = this.selectedAssetImpact ? Number(this.selectedAssetImpact.name || this.selectedAssetImpact.id || 1) : 1;

      this.inherentRiskScore = impactScore * likelihoodScore * assetMult;
    } else {
      this.inherentRiskScore = null;
    }
  }

  hasMasterResidualSet: boolean = false;

  onImpactChange(impactId: number) {
    this.selectedRiskImpact =
      this.riskImpactList.find((i) => i.id === impactId) || null;
    this.calculateRiskScore();
    if (!this.hasMasterResidualSet && (!this.selectedResidualImpact || !this.hasResidualRiskChanged())) {
      this.selectedResidualImpact = this.selectedRiskImpact;
      this.calculateResidualRiskScore();
    }
  }

  onLikelihoodChange(likelihoodId: number) {
    this.selectedRiskLikelihood =
      this.riskLikelihoodList.find((l) => l.id === likelihoodId) || null;
    this.calculateRiskScore();
    if (!this.hasMasterResidualSet && (!this.selectedResidualLikelihood || !this.hasResidualRiskChanged())) {
      this.selectedResidualLikelihood = this.selectedRiskLikelihood;
      this.calculateResidualRiskScore();
    }
  }

  setRiskScoreFromRes() {
    if (!this.res) return;

    this.hasMasterResidualSet = !!(this.res.residual_risk_impact || this.res.risk?.residual_risk_impact);

    const rawImpact = this.res.risk_impact || this.res.risk?.risk_impact;
    const rawLikelihood = this.res.risk_likelihood || this.res.risk?.risk_likelihood;
    const rawInherentScore = this.res.inherent_risk_score ?? this.res.risk?.inherent_risk_score;

    const rawResidualImpact = this.res.residual_risk_impact || this.res.risk?.residual_risk_impact;
    const rawResidualLikelihood = this.res.residual_risk_likelihood || this.res.risk?.residual_risk_likelihood;
    const rawResidualScore = this.res.residual_risk_score ?? this.res.risk?.residual_risk_score;

    const impactId = typeof rawImpact === 'object' ? rawImpact?.id : rawImpact;
    if (impactId) {
      this.selectedRiskImpact = this.riskImpactList.find(
        (i) => i.id === Number(impactId)
      );
    }

    const likelihoodId = typeof rawLikelihood === 'object' ? rawLikelihood?.id : rawLikelihood;
    if (likelihoodId) {
      this.selectedRiskLikelihood = this.riskLikelihoodList.find(
        (l) => l.id === Number(likelihoodId)
      );
    }

    if (rawInherentScore != null && rawInherentScore > 0) {
      this.inherentRiskScore = Number(rawInherentScore);
    } else {
      this.calculateRiskScore();
    }

    const residualImpactId = typeof rawResidualImpact === 'object' ? rawResidualImpact?.id : rawResidualImpact;
    if (residualImpactId) {
      this.selectedResidualImpact = this.riskImpactList.find(
        (i) => i.id === Number(residualImpactId)
      );
      this.initialResidualImpactId = Number(residualImpactId);
    }

    const residualLikelihoodId = typeof rawResidualLikelihood === 'object' ? rawResidualLikelihood?.id : rawResidualLikelihood;
    if (residualLikelihoodId) {
      this.selectedResidualLikelihood = this.riskLikelihoodList.find(
        (l) => l.id === Number(residualLikelihoodId)
      );
      this.initialResidualLikelihoodId = Number(residualLikelihoodId);
    }

    if (rawResidualScore != null && rawResidualScore > 0) {
      this.residualRiskScore = Number(rawResidualScore);
    } else {
      this.calculateResidualRiskScore();
    }
  }

  hasResidualRiskChanged(): boolean {
    return this.selectedResidualImpact?.id !== this.initialResidualImpactId ||
      this.selectedResidualLikelihood?.id !== this.initialResidualLikelihoodId;
  }
  getRiskScoreColor(): string {
    return this.riskService.getRiskScoreColorFromConfig(this.inherentRiskScore, this.riskMatrixConfig);
  }

  calculateResidualRiskScore() {
    const impact = this.selectedResidualImpact || this.selectedRiskImpact;
    const likelihood = this.selectedResidualLikelihood || this.selectedRiskLikelihood;

    if (impact && likelihood) {
      const impactScore = Number(
        impact.name || impact.id
      );
      const likelihoodScore = Number(
        likelihood.name || likelihood.id
      );
      const assetMult = this.selectedAssetImpact ? Number(this.selectedAssetImpact.name || this.selectedAssetImpact.id || 1) : 1;

      this.residualRiskScore = impactScore * likelihoodScore * assetMult;
    } else {
      this.residualRiskScore = null;
    }
  }

  get effectiveResidualImpact(): any {
    return this.selectedResidualImpact || this.selectedRiskImpact;
  }

  get effectiveResidualLikelihood(): any {
    return this.selectedResidualLikelihood || this.selectedRiskLikelihood;
  }

  get effectiveResidualRiskScore(): number | null {
    return this.residualRiskScore ?? this.inherentRiskScore;
  }

  getEffectiveResidualRiskScoreColor(): string {
    return this.riskService.getRiskScoreColorFromConfig(this.effectiveResidualRiskScore, this.riskMatrixConfig);
  }

  onResidualImpactChange(impactId: number) {
    this.selectedResidualImpact = this.riskImpactList.find(
      (i) => i.id === impactId
    );
    if (!this.selectedResidualLikelihood) {
      this.selectedResidualLikelihood = this.selectedRiskLikelihood;
    }
    this.calculateResidualRiskScore();
  }

  onResidualLikelihoodChange(likelihoodId: number) {
    this.selectedResidualLikelihood = this.riskLikelihoodList.find(
      (l) => l.id === likelihoodId
    );
    if (!this.selectedResidualImpact) {
      this.selectedResidualImpact = this.selectedRiskImpact;
    }
    this.calculateResidualRiskScore();
  }

  getResidualRiskScoreColor(): string {
    return this.riskService.getRiskScoreColorFromConfig(this.residualRiskScore, this.riskMatrixConfig);
  }

  get hasActions(): boolean {
    return !!(
      this.res?.risk_mitigation?.length &&
      this.res.risk_mitigation.some((m: any) => m.risk_mitigation?.action)
    );
  }

  get allMitigationTasksClosed(): boolean {
    const controls = this.riskMetricCreateForm?.controls;
    if (!controls || controls.length === 0) return false;
    const activeControls = controls.filter(
      (ctrl: any) => !ctrl.get('is_ignored')?.value
    );
    if (activeControls.length === 0) return false;
    return activeControls.every(
      (ctrl: any) => ctrl.get('has_action')?.value && ctrl.get('status')?.value === 'Closed'
    );
  }

  getMaxScore(): number {
    const maxImpact = Math.max(
      ...this.riskImpactList.map((i) => Number(i.name))
    );
    const maxLikelihood = Math.max(
      ...this.riskLikelihoodList.map((l) => Number(l.name))
    );
    return maxImpact * maxLikelihood;
  }

  getScoreColor(score: number): string {
    return this.riskService.getRiskScoreColorFromConfig(score, this.riskMatrixConfig);
  }

  getRiskRanges() {
    const maxScore = this.getMaxScore();
    if (this.riskMatrixConfig?.length) {
      const low = this.riskMatrixConfig.find((c: any) => c.label?.toLowerCase() === 'low' || c.order === 1);
      const medium = this.riskMatrixConfig.find((c: any) => c.label?.toLowerCase() === 'medium' || c.order === 2);
      const high = this.riskMatrixConfig.find((c: any) => c.label?.toLowerCase() === 'high' || c.order === 3);
      if (low || medium || high) {
        return {
          low: low ? `${low.min_score} – ${low.max_score}` : '1 – 5',
          medium: medium ? `${medium.min_score} – ${medium.max_score}` : '6 – 14',
          high: high ? `${high.min_score} – ${maxScore}` : `15 – ${maxScore}`,
        };
      }
    }

    return {
      low: '1 – 5',
      medium: '6 – 14',
      high: `15 – ${maxScore}`,
    };
  }

  isSelectedCell(impactId: number, likelihoodId: number): boolean {
    return (
      this.selectedRiskImpact?.id === impactId &&
      this.selectedRiskLikelihood?.id === likelihoodId
    );
  }

  isResidualSelectedCell(impactId: number, likelihoodId: number): boolean {
    return (
      this.effectiveResidualImpact?.id === impactId &&
      this.effectiveResidualLikelihood?.id === likelihoodId
    );
  }

  getRiskScore(impact: string, likelihood: string): number {
    return Number(impact) * Number(likelihood);
  }

  getFilteredControls(type: "preventive" | "detective"): any[] {
    return this.riskControlOptions.filter((c) => c.control_type === type);
  }

  displayControl(option: any): string {
    return option?.description ?? option ?? "";
  }

  setDecision(controlGroup: any, decision: string) {
    if (controlGroup.get('review_decision')) {
      const current = controlGroup.get('review_decision').value;
      const nextDecision = current === decision ? null : decision;
      controlGroup.get('review_decision').setValue(nextDecision);
      if (nextDecision !== 'Approve') {
        controlGroup.get('add_to_master')?.setValue(false);
      }
    }
  }

  toggleAddToMaster(controlGroup: any) {
    if (controlGroup.get('review_decision')?.value === 'Approve') {
      const current = controlGroup.get('add_to_master')?.value || false;
      controlGroup.get('add_to_master')?.setValue(!current);
    }
  }
}

